import { sdk } from '@/lib/medusa';

function getSource() {
  const base = process.env.NEXT_PUBLIC_BASE_URL || '';
  try {
    return base ? new URL(base).hostname.replace(/^www\./, '') : 'oppermann-kunst.de';
  } catch {
    return 'oppermann-kunst.de';
  }
}

/**
 * Submit a generic contact-form message.
 */
export async function submitContact({ name, email, subject, message }) {
  await sdk.client.fetch('/contact', {
    method: 'POST',
    body: {
      type: 'contact',
      name,
      email,
      subject,
      message,
      source: getSource(),
      submitted_at: new Date().toISOString(),
    },
    headers: { 'Content-Type': 'application/json' },
  });
}

/**
 * Submit a price request tied to a specific product (used for products tagged
 * `Unverkäuflich`).
 */
export async function submitPriceRequest({
  name,
  email,
  message,
  productId,
  productHandle,
}) {
  await sdk.client.fetch('/contact', {
    method: 'POST',
    body: {
      type: 'price_request',
      name,
      email,
      message,
      product_id: productId,
      product_handle: productHandle,
      source: getSource(),
      submitted_at: new Date().toISOString(),
    },
    headers: { 'Content-Type': 'application/json' },
  });
}
